var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
export { default as ggAmountControl } from './plugins/amountcontrol';
export { default as ggAttachForm } from './plugins/attachform';
export { default as ggAutoCurrent } from './plugins/autocurrent';
export { default as ggCallback } from './plugins/callback';
export { default as ggCatalog } from './plugins/catalog';
export { default as ggCustomScroll } from './plugins/customscroll';
export { default as ggCustomSelect } from './plugins/customselect';
export { default as ggDraggin } from './plugins/dragging';
export { default as ggFormsController } from './plugins/formscontroller';
export { default as ggPopup } from './plugins/popup';
export { default as ggResponsive } from './plugins/responsive';
export { default as formatNumberWithSpaces } from './utils/formatNumberWithSpaces';
export { default as pluralize } from './utils/pluralize';
export default {
    $: window.jQuery,
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    log: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.config.log) {
            console.log.apply(console, args);
        }
    },
    use: function () {
        var _this = this;
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        var dom = [];
        this.config = __assign({
            setCurrent: true,
            log: false
        }, window.GG);
        modules.forEach(function (_a) {
            var type = _a.type, module = __rest(_a, ["type"]);
            if (!type) {
                Object.keys(module).forEach(function (key) {
                    if (key === 'config') {
                        _this.config = __assign({}, _this.config, module[key]);
                    }
                    else {
                        _this[key] = module[key];
                    }
                });
            }
            else if (type === 'core') {
                module.init(_this);
            }
            else if (type === 'dom') {
                dom.push(module);
            }
        });
        if (dom.length) {
            document.addEventListener('DOMContentLoaded', function () {
                dom.forEach(function (module) {
                    module.init(_this);
                });
            });
        }
    }
};
